<template>
<!-- 群艺师资 -->
    <div class="teacher_warp">
        <BasePage ref='basePage' >
            <template slot="mooc">
                <div class="mooc_box">
                    <div class="mooc_title">查看更多>></div>
                    <div class="mooc_list">
                        <div class="mooc_list_item" @click="toDetail('mooc',item)" v-for="item in moocList" :key="item.id">
                            <el-image class="item_img" :src="item.coverUrl"></el-image>
                            <!-- <div class="item_status">已更新2期</div> -->
                            <div class="item_info">
                                <div class="info_title ellipsis">{{item.title}}</div>
                                <div class="itme_date"> 最近更新：{{item.updateTime}} </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template scope={item}>
                <div class="teacher_item_box" @click="toDetail('teacher',item)">
                    <el-image class="user_img" :src="item.imageUrl">
                        <div slot="placeholder" style="text-align:center;margin-top:50px;">
                            <i class="el-icon-loading"></i>
                        </div>
                    </el-image>
                    <div class="user_name">{{item.name}}</div>
                    <div class="user_tags">
                        <Tag effect="plain" type="info" size="medium">{{item.major}}</Tag>
                    </div>
                </div>
            </template>
        </BasePage>
        
    </div>
</template>

<script>
import BasePage from '@c/BasePage';
import { Tag } from 'element-ui';
import { post } from '@u/request';

export default {
    name: 'teacher',
    components: {
        BasePage,
        Tag
    },
    data() {
        return {
            moocList: []
        }
    },
    beforeRouteUpdate(to, from, next) {
        this.$refs.basePage.loadImage(to.query.id)
        next()
    },
    methods: {
        toDetail(path,item) {
            this.$router.push(`/${path}/detail/${item.id}`)
        },
        async loadMooc() {
            const params = {
                pid: this.$route.query.id,
                venueIds: this.$store.getters.venueId
            }
            const { data } = await post('resource/offlinesource/list', params);
            this.moocList = data;
        }
    },
    mounted() {
        this.loadMooc()
    }
}
</script>

<style scoped lang="scss">
.teacher_warp {
    background: #f8f8f8;
    .mooc_box {
        line-height: 1;
        .mooc_title {
            text-align: right;
            color: #b30202;
            cursor: pointer;
        }
        .mooc_list {
            margin-top: 10px;
            display: flex;
        }
        .mooc_list_item {
            width: 386px;
            margin-right: 20px;
            background: #fff;
            box-shadow: 0 10px 18px 0 rgba(0,0,0,.05);
            border-radius: 5px;
            cursor: pointer;
            overflow: hidden;
            position: relative;
            &:nth-last-child(1) {
                margin-right: 0;
            }
            .item_img {
                width: 100%;
                height: 180px;
                ::v-deep .el-image__inner {
                    object-fit: cover; 
                }
            }
            .item_status {
                position: absolute;
                top: 18px;
                left: 18px;
                width: 85px;
                height: 23px;
                line-height: 23px;
                border-radius: 23px 23px 23px 0;
                font-weight: 400;
                text-align: center;
                color: #fff;
                font-size: 14px;
                background: #07bb3f;
            }
            .item_info {
                padding: 18px;
                font-size: 14px;
                line-height: 1;
            }
            .info_title {
                font-size: 18px;
                color: #000;
                padding-bottom: 18px;
            }
            .itme_date {
                color: #2f7ef7;
                padding-bottom: 15px;
            }
        }
    }
    .teacher_item_box {
        width: 231px;
        margin-right: 10px;
        height: 335px;
        padding-top: 30px;
        background: #fff;
        border-radius: 5px;
        margin-bottom: 20px;
        cursor: pointer;
        text-align: center;
        &:nth-child(5n) {
            margin-right: 0;
        }
        .user_img {
            width: 129px;
            height: 129px;
            border-radius: 50%;
        }
        .user_name {
            font-size: 18px;
            padding: 30px 0 50px;
            font-weight: bold;
        }
    }
}
</style>